(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SupplierContent = factory();
})(globalThis, function () {
  function clean(root) {
    let removed = 0;
    root.querySelectorAll('#WidgetFloaterPanels, #MicrosoftTranslatorWidget, #gtx-trans, #BFI_DATA').forEach(node => {
      node.remove();
      removed++;
    });
    // Earlier imports stripped widget IDs, but retained the complete language table and UI copy.
    for (const node of [...root.querySelectorAll('div')].reverse()) {
      const text = node.textContent.replace(/\s+/g, ' ').trim();
      if (/^TRANSLATE with\b/i.test(text) && /Bing Webmaster Portal/i.test(text) &&
          /EMBED THE SNIPPET BELOW IN YOUR SITE/i.test(text) && node.querySelector('table') && /Klingon/.test(text)) {
        node.remove();
        removed++;
      }
    }
    root.querySelectorAll('img').forEach(image => {
      const src = image.getAttribute('src');
      if (!src || /\/(?:null|undefined)(?:[?#]|$)/i.test(src)) {
        image.remove();
        removed++;
      }
    });
    return removed;
  }
  function containsWidget(text) {
    return /TRANSLATE\s+with|Bing Webmaster Portal|WidgetFloaterPanels|EMBED THE SNIPPET BELOW IN YOUR SITE/i.test(text);
  }
  return { clean, containsWidget };
});
